/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_FeedbackInputs */

const en_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback`)
};

const fr_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const de_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückmeldung`)
};

const it_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback`)
};

const ru_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратная связь`)
};

const es_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comentario`)
};

const zh_cn2_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反馈`)
};

const ja_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィードバック`)
};

const hi_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिक्रिया`)
};

const pt_pt2_manual_qc_type_feedback = /** @type {(inputs: Manual_Qc_Type_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opinião`)
};

/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Manual_Qc_Type_FeedbackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_feedback = /** @type {((inputs?: Manual_Qc_Type_FeedbackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_FeedbackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_type_feedback(inputs)
	if (locale === "de") return de_manual_qc_type_feedback(inputs)
	if (locale === "it") return it_manual_qc_type_feedback(inputs)
	if (locale === "ru") return ru_manual_qc_type_feedback(inputs)
	if (locale === "es") return es_manual_qc_type_feedback(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_type_feedback(inputs)
	if (locale === "ja") return ja_manual_qc_type_feedback(inputs)
	if (locale === "hi") return hi_manual_qc_type_feedback(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_type_feedback(inputs)
	return en_manual_qc_type_feedback(inputs)
});